/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  GetApiBookingPaymentsList200,
  GetApiBookingPaymentsListParams,
  GetApiPaymentsList200,
  GetApiPaymentsListParams,
  GetApiPropertyPaymentsList200,
  GetApiPropertyPaymentsListParams,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiBookingPaymentsListResponse200 = {
  data: GetApiBookingPaymentsList200
  status: 200
}

export type getApiBookingPaymentsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiBookingPaymentsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiBookingPaymentsListResponseSuccess = (getApiBookingPaymentsListResponse200) & {
  headers: Headers;
};
export type getApiBookingPaymentsListResponseError = (getApiBookingPaymentsListResponse401 | getApiBookingPaymentsListResponse403) & {
  headers: Headers;
};

export type getApiBookingPaymentsListResponse = (getApiBookingPaymentsListResponseSuccess | getApiBookingPaymentsListResponseError)

export const getGetApiBookingPaymentsListUrl = (id: string,
    params?: GetApiBookingPaymentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/bookings/${id}/payments?${stringifiedParams}` : `/api/bookings/${id}/payments`
}

export const getApiBookingPaymentsList = async (id: string,
    params?: GetApiBookingPaymentsListParams, options?: RequestInit): Promise<getApiBookingPaymentsListResponse> => {
  
  return customFetch<getApiBookingPaymentsListResponse>(getGetApiBookingPaymentsListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiPaymentsListResponse200 = {
  data: GetApiPaymentsList200
  status: 200
}

export type getApiPaymentsListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPaymentsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPaymentsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiPaymentsListResponseSuccess = (getApiPaymentsListResponse200) & {
  headers: Headers;
};
export type getApiPaymentsListResponseError = (getApiPaymentsListResponse400 | getApiPaymentsListResponse401 | getApiPaymentsListResponse403) & {
  headers: Headers;
};

export type getApiPaymentsListResponse = (getApiPaymentsListResponseSuccess | getApiPaymentsListResponseError)

export const getGetApiPaymentsListUrl = (params?: GetApiPaymentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses[]","types[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/payments?${stringifiedParams}` : `/api/payments`
}

export const getApiPaymentsList = async (params?: GetApiPaymentsListParams, options?: RequestInit): Promise<getApiPaymentsListResponse> => {
  
  return customFetch<getApiPaymentsListResponse>(getGetApiPaymentsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiPropertyPaymentsListResponse200 = {
  data: GetApiPropertyPaymentsList200
  status: 200
}

export type getApiPropertyPaymentsListResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type getApiPropertyPaymentsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyPaymentsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiPropertyPaymentsListResponseSuccess = (getApiPropertyPaymentsListResponse200) & {
  headers: Headers;
};
export type getApiPropertyPaymentsListResponseError = (getApiPropertyPaymentsListResponse400 | getApiPropertyPaymentsListResponse401 | getApiPropertyPaymentsListResponse403) & {
  headers: Headers;
};

export type getApiPropertyPaymentsListResponse = (getApiPropertyPaymentsListResponseSuccess | getApiPropertyPaymentsListResponseError)

export const getGetApiPropertyPaymentsListUrl = (id: string,
    params?: GetApiPropertyPaymentsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["statuses[]","types[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : v.toString()));
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${id}/payments?${stringifiedParams}` : `/api/properties/${id}/payments`
}

export const getApiPropertyPaymentsList = async (id: string,
    params?: GetApiPropertyPaymentsListParams, options?: RequestInit): Promise<getApiPropertyPaymentsListResponse> => {
  
  return customFetch<getApiPropertyPaymentsListResponse>(getGetApiPropertyPaymentsListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


